import React, { useId, InputHTMLAttributes } from 'react';
import Icon from '../icon/icon.component';
import './checkbox.style.scss';

interface IInputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  children?: React.ReactNode;
}

const Checkbox = ({ label, children, ...rest }: IInputProps) => {
  const id = rest.id ?? useId();
  return (
    <div className="checkbox__wrapper">
      <input type="checkbox" id={id} className="checkbox__input" {...rest} />
      <label className="checkbox__label" htmlFor={id}>
        <span className="checkbox__icon">
          <Icon name="Check" size={18} />
        </span>
        {label && <span className="checkbox__text">{label}</span>}
        {children && <span className="checkbox__text">{children}</span>}
      </label>
    </div>
  );
};

export default Checkbox;
